import ForgotPasswordModal from "./forgot-password-modal.component";

export default ForgotPasswordModal;
